/*
 * MDB shim for DropdownMenu
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/pageHeader.jsx
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import MUIMenu from "@mui/material/Menu";
import { useContext } from "react";
import { DropdownContext } from "./Dropdown";

export default function DropdownMenu({ children, basic, disablePortal = true, ...rest }) {
    const context = useContext(DropdownContext);

    function handleClose() {
        context?.setAnchorEl(null);
    }

    return (
        <MUIMenu
            anchorEl={context?.anchorEl}
            open={Boolean(context?.open)}
            onClose={handleClose}
            disablePortal={disablePortal}
            {...rest}
        >
            {children}
        </MUIMenu>
    );
}